/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { Address } from './';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './';
import type { Logo } from './';
import {
    LogoFromJSON,
    LogoFromJSONTyped,
    LogoToJSON,
} from './';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';

/**
 * 
 * @export
 * @interface Experience
 */
export interface Experience {
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    company: string;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    organizationName?: string;
    /**
     * 
     * @type {Logo}
     * @memberof Experience
     */
    logo?: Logo;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    logoUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof Experience
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof Experience
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Experience
     */
    asFreelancer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Experience
     */
    currentJob?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    missionId?: string;
    /**
     * 
     * @type {Address}
     * @memberof Experience
     */
    location?: Address;
    /**
     * 
     * @type {ActivityArea}
     * @memberof Experience
     */
    activityArea?: ActivityArea;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof Experience
     */
    skills?: Array<Skill>;
}

/**
 * Check if a given object implements the Experience interface.
 */
export function instanceOfExperience(value: object): value is Experience {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function ExperienceFromJSON(json: any): Experience {
    return ExperienceFromJSONTyped(json, false);
}

export function ExperienceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Experience {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'],
        'company': json['company'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'logo': json['logo'] == null ? undefined : LogoFromJSON(json['logo']),
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'asFreelancer': json['asFreelancer'] == null ? undefined : json['asFreelancer'],
        'currentJob': json['currentJob'] == null ? undefined : json['currentJob'],
        'description': json['description'] == null ? undefined : json['description'],
        'missionId': json['missionId'] == null ? undefined : json['missionId'],
        'location': json['location'] == null ? undefined : AddressFromJSON(json['location']),
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
        'skills': json['skills'] == null ? undefined : ((json['skills'] as Array<any>).map(SkillFromJSON)),
    };
}

export function ExperienceToJSON(value?: Experience | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'company': value['company'],
        'companyId': value['companyId'],
        'organizationName': value['organizationName'],
        'logo': LogoToJSON(value['logo']),
        'logoUrl': value['logoUrl'],
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'asFreelancer': value['asFreelancer'],
        'currentJob': value['currentJob'],
        'description': value['description'],
        'missionId': value['missionId'],
        'location': AddressToJSON(value['location']),
        'activityArea': ActivityAreaToJSON(value['activityArea']),
        'skills': value['skills'] == null ? undefined : ((value['skills'] as Array<any>).map((v) => SkillToJSON(v))),
    };
}

